export default __webpack_public_path__ + "static/media/DucLuu.5129687f.png";